<template>
    <div>
        <UnsubscribedComponent></UnsubscribedComponent>
    </div>
</template>

<script>
import UnsubscribedComponent from '../components/UnsubscribedComponent.vue'
export default {
    name: "UnsubscribedView",
    data(){
        return {

        }
    },
    components: {
        UnsubscribedComponent
    }
}
</script>